import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b19dff82&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b19dff82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19dff82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b19dff82')) {
      api.createRecord('b19dff82', component.options)
    } else {
      api.reload('b19dff82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b19dff82&scoped=true&", function () {
      api.rerender('b19dff82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/about/index.vue"
export default component.exports